import { useHistory } from "react-router-dom";
import React from "react";

import {
  Box,
  Button,
  Card,
  CardHeader,
  Divider,
  Table,
} from "@material-ui/core";

import { Skeleton } from "./components";
import { TableCardProps } from "./types";

const TableCard: React.FC<TableCardProps> = ({
  title,
  loading = false,
  children,
  text,
  action,
  className,
  ...restProps
}) => {
  const history = useHistory();
  const hasActionButton = text && action;
  const onButtonClick = () => {
    if (!hasActionButton || !action) {
      return;
    }
    if (typeof action === "string") {
      history.push(action);
    }
    if (typeof action === "function") {
      action();
    }
  };

  return (
    <Card {...restProps}>
      {title && (
        <CardHeader
          title={title}
          className={className}
          action={
            hasActionButton && (
              <Box display="flex" alignItems="center" justifyContent="center">
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  title={`${text} ${title}`}
                  onClick={onButtonClick}
                  disabled={false}
                >
                  {text}
                </Button>
              </Box>
            )
          }
        />
      )}

      <Divider />
      {loading ? <Skeleton /> : <Table>{children}</Table>}
    </Card>
  );
};

export default TableCard;
